import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
// import { Product } from '../../product.model';
import { ProductService } from '../../product.service';

@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.css']
})
export class ListItemComponent {
  @Input() product;
  @Input() index: number

  constructor(private productService : ProductService){

  }

  onDelete(id) {
    this.productService.deleteProduct(id)

  }
  // onDelete(id){
  //   this.productService.addNoImage(id)
  // }
}
